import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PrimeNGConfig } from 'primeng/api';
import { AppResource } from 'src/app/app.resource';
import * as fromRoot from '../../../core/state/core.state';
import { Resource } from 'src/app/resources/resource';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html'
})
export class Error404Component implements OnInit {
  resource: Resource;

  constructor(
    private readonly primengConfig: PrimeNGConfig,
    private readonly store: Store<fromRoot.State>,
    protected resources: AppResource
  ) {
    this.resource = resources['resource'];
  }

  ngOnInit() {}
}
